import type { Config } from 'u-next/config';

const config = JSON.parse(process.env.publicConfig ?? '') as Config;

/**
 * server/client両方で参照可能
 */
export const appPublicConfig = config;
